import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="about"
      ref={ref}
      className="py-20 md:py-32 bg-black relative overflow-hidden"
      data-testid="about-section"
    >
      {/* Background Accent */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-96 h-96 spotlight-effect opacity-30"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            className="section-title font-cinzel text-4xl md:text-6xl font-semibold text-gold mb-4 tracking-wide"
            data-testid="about-title"
          >
            The Prime Experience
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto"></div>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center space-y-6"
        >
          <p
            className="font-montserrat text-lg md:text-xl text-neutral-300 leading-relaxed"
            data-testid="about-description"
          >
            At <span className="text-gold font-semibold">Centurio Prime</span>, we've redefined the game. 
            This isn't just a snooker club—it's a sanctuary for those who demand excellence.
          </p>
          
          <p className="font-montserrat text-lg md:text-xl text-neutral-300 leading-relaxed">
            From <span className="text-gold">tournament-grade tables</span> with premium cloth quality to 
            <span className="text-gold"> luxury leather seating</span>, every detail has been crafted to elevate your experience.
          </p>

          <p className="font-montserrat text-lg md:text-xl text-neutral-300 leading-relaxed">
            Whether you're a serious player or a connoisseur of refined spaces, Centurio Prime offers an 
            <span className="text-gold"> elite environment</span> where precision meets prestige.
          </p>

          <div className="pt-8">
            <p className="font-playfair text-2xl md:text-3xl text-gold italic">
              "Where every shot is a statement."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
